import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import Surplus from '../../../components/factoring/Surplus';
import DownloadClientSummariesDialog from '../../../components/dialogs/client-summaries-dialog/DownloadClientSummariesDialog';
import useBooleanState from '../../../hooks/useBooleanState';
import useSelectedCompany from '../../../hooks/useSelectedCompany';

const OperationsSummaryActions = ({ showSurplus }) => {
  const selectedCompany = useSelectedCompany();
  const [portfolioOpen, togglePortfolio] = useBooleanState(false);

  return (
    <>
      {showSurplus && (
        <Box
          sx={{
            width: { xs: 150, md: 180 },
            height: 40,
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            '& .MuiButton-root': { px: '18px', whiteSpace: 'nowrap' },
          }}
        >
          <Surplus />
        </Box>
      )}
      <Button
        color="primary"
        variant="contained"
        size="medium_2"
        startIcon={<SimCardDownloadOutlinedIcon />}
        onClick={() => togglePortfolio(true)}
        id="toggle-download-portfolio"
        sx={{
          whiteSpace: 'nowrap',
          flexShrink: 0,
          ...(showSurplus && { width: { xs: 160, md: 200 }, height: 40 }),
        }}
      >
        <Typography variant="small_2" fontWeight={700}>
          Descargar resumen
        </Typography>
      </Button>
      <DownloadClientSummariesDialog
        customCompany={selectedCompany?.id}
        open={portfolioOpen}
        onClose={() => togglePortfolio(false)}
        product="FACTORING"
      />
    </>
  );
};

OperationsSummaryActions.propTypes = {
  showSurplus: PropTypes.bool,
};

OperationsSummaryActions.defaultProps = {
  showSurplus: false,
};

export default OperationsSummaryActions;
